import { observer } from 'mobx-react';
import { FC, useMemo } from 'react';
import Skeleton from 'react-loading-skeleton';
import { crossSellingModalStore } from '../store';
import { localeStore } from 'src/mobx/localesStore';
import { IProductV4 } from 'src/types/product';
import { getTranslate } from 'src/utils/helpers';
import { Checkbox } from 'src/view/components/Controls/Checkbox/Checkbox';

interface IProps {
  item?: IProductV4;
}

const CrossSellingModalItem: FC<IProps> = observer(({ item }: IProps) => {
  const { selectedItems, selectItem } = crossSellingModalStore;

  const clickItem = () => {
    if (!item || item.out_of_stock) return;
    selectItem(item.id);
  };

  const isActive = useMemo((): boolean => Boolean(item && selectedItems.find((_item: IProductV4) => _item.id === item.id)), [item, selectedItems]);

  return (
    <li className="d-flex flex-row align-items-center">
      {item ? (
        <div className="d-flex flex-row align-items-center">
          <Checkbox
            value={isActive}
            name={getTranslate(item.name)}
            label={getTranslate(item.name)}
            disabled={Boolean(item.out_of_stock)}
            onClick={clickItem}
          />
          {item.out_of_stock ? (
            <p className="family-medium text-size-12 color-gray2 text-uppercase letter-spacing-12 ml-4">{localeStore.t('out_of_stock')}</p>
          ) : null}
        </div>
      ) : (
        <>
          <Skeleton width={24} height={24} style={{ borderRadius: 6 }} className="mr-4" />
          <Skeleton width={110} height={19.2} />
        </>
      )}
    </li>
  );
});

export default CrossSellingModalItem;
